import { createRoot } from "@wordpress/element";
import App from "./components/App";

import "@/utils/i18n";

document.querySelectorAll(".wp-block-weather-weather-summary").forEach((el) => {
	const root = el.querySelector(".weather-summary__app");

	if (root) {
		createRoot(root).render(<App />);
	}
});
